module.exports = __webpack_public_path__ + "img/3-4.1e8217d1.svg";